import api from '@pray/shared/utils/api';

export async function deletePushCampaign({ artistId = undefined, campaignId = undefined }) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!campaignId) throw new Error('Campaign ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/push/${campaignId}`;
  const response = await api.executeDeleteRequest(url);

  return response.data;
}
